module.exports = __webpack_public_path__ + "media/fap.e594870e.wav";